<template>
  <div>
      <label for="dream" class="vs-input--label block text-sm">
          {{ label }}
      </label>
      <v-select
          v-model="dream"
          id="dream"
          clearable
          multiple
          :options="dreamOptions"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          @input="input"
      />
  </div>
</template>
<script>
import _ from 'lodash'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
  },
  props: {
    value: {
      type: String,
      required: false,
      default: () => null
    },
    label: {
      type: String,
      required: false,
      default: () => 'Dream'
    }
  },
  data () {
    return {
      dream: null,
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (value) {
        this.dream = _.find(this.dreamOptions, { value })
      }
    }
  },
  computed: {
    dreamOptions () {
      return _.map(this.$store.getters.dreams, (dream) => Object.assign({}, {
        label: this.$options.filters.truncate_dots(dream.title, 80),
        value: dream.id
      }))
    },
  },
  methods: {
    input (val) {
      const dreamId = _.get(val, 'value')
      this.$emit('input', dreamId)
    }
  }
}
</script>
